/* eslint-disable camelcase */
/* eslint-disable react/display-name */
/**
 * @file SeroStatusHepatitisBView.jsx
 * @author Daniel Aguirre
 * @description SeroStatusHepatitisB View Page
 */

// Dependencies
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';
import DashboardDoughnut from 'components/Charts/DashboardDoughnut';
import styleGuideColors from 'commons/styleGuideColors';
import { useTranslation } from 'react-i18next';
import DashboardCard from 'components/DashboardCard';
import useTruncateAndFormat from 'hook/useTruncateAndFormat';

/**
 * SeroStatusHepatitisB View
 * @param { Object } dashboardStaffActions - DashboardStaff Actions.
 * @return { Node } React node.
 */

function SeroStatusHepatitisBView({ dashboardStaffActions, clinicId }) {
  const { t: translate } = useTranslation();
  const history = useHistory();
  const [chartData, setChartData] = useState([]);

  const { getSeroStatusHepatitisB } = dashboardStaffActions;

  const onGetData = (_, resp) => {
    let data = [];
    const classifications = [
      {
        label: 'Inmune',
        color: styleGuideColors.baxterBrandTeal
      },
      {
        label: 'Susceptible',
        color: styleGuideColors.baxterBrandBaxterBlue
      },
      {
        label: 'Susceptible no respondedor',
        color: styleGuideColors.graphYellow
      },
      {
        label: 'Infectado',
        color: styleGuideColors.alertError
      },
      {
        label: 'No registra',
        color: styleGuideColors.graphGreyStrokes
      }
    ];

    let total = 0;

    if (resp?.data) {
      resp.data.forEach(({ cantidad }) => {
        total += cantidad;
      });
      classifications.forEach(({ label, color }) => {
        const respElement = resp.data.find(
          ({ clasificacion }) => clasificacion === label
        );
        if (respElement) {
          const value = (respElement.cantidad * 100) / total;
          data = [
            ...data,
            {
              value: useTruncateAndFormat(value, 2),
              label: translate(`dashboardStaff.${label}`),
              key: label,
              color,
              cantidad: respElement.cantidad
            }
          ];
        }
      });
      setChartData(data);
    }
  };

  useEffect(() => {
    getSeroStatusHepatitisB({ clinicId }, onGetData);
  }, [clinicId, translate]);

  const handleDetailClick = (index) => {
    const { key: classification, cantidad: totalItems } = chartData[index];
    history.push(
      `/main/dashboard-detail/seroStatusHepatitisB/${classification}/${totalItems}`
    );
  };

  return (
    <DashboardCard id="F8" loading={chartData.length === 0}>
      <DashboardDoughnut
        title={translate('dashboardStaff.seroStatusHepatitisB')}
        dataValues={chartData}
        onDetailClick={handleDetailClick}
      />
    </DashboardCard>
  );
}

/**
 * Component definition of proptypes.
 */
SeroStatusHepatitisBView.propTypes = {
  dashboardStaffActions: PropTypes.shape({
    getSeroStatusHepatitisB: PropTypes.func.isRequired
  }),
  clinicId: PropTypes.any
};

export default SeroStatusHepatitisBView;
